<div class="container-fluid py-3">
  <div class="d-flex justify-content-between align-items-center mb-3">
    <h5 class="fw-bold">Existing Auditoriums</h5>
    <button class="btn btn-primary btn-sm" (click)="auditoriumModel = true">
      <i class="fas fa-plus me-1"></i> Add Auditorium
    </button>
  </div>


  <swiper [config]="configCity" navigation pagination autoplay class="auditorium-swiper py-3">
    <ng-container *ngFor="let item of auditoriumDetails">
      <ng-template swiperSlide>
        <div class="card auditorium-card shadow-sm h-100">
          <img
            [src]="configService.getConfig().END_POINT + '/api/front-end/auditorium-details/getFile/' + item.auditoriumSeq"
            class="card-img-top" alt="Auditorium Image" loading="lazy" (error)="onImageError($event)" />
          <div class="card-body d-flex flex-column">
            <div class="mb-2">
              <small class="text-muted d-block">{{ item.location }}</small>
              <strong class="small">{{ item.schoolName }}</strong>
            </div>
            <div class="mt-auto d-flex justify-content-end align-items-center gap-2">
              <!-- Custom Small Toggle -->
              <label class="switch m-0" title="Click to change Status">
                <input type="checkbox" [checked]="item.status === 'Active'" (change)="toggleStatus(item.auditoriumSeq, $event)" />
                <span class="slider round"></span>
              </label>

              <!-- Edit Button -->
              <button class="btn btn-sm btn-outline-primary" (click)="editAuditorium(item)" title="Edit">
                <i class="bi bi-pencil-fill"></i>
              </button>

              <!-- Delete Button -->
              <button class="btn btn-sm btn-outline-danger" (click)="deleteAuditorium(item)" title="Delete">
                <i class="bi bi-trash-fill"></i>
              </button>
            </div>

          </div>
        </div>
      </ng-template>
    </ng-container>
  </swiper>



  <!-- Empty State (Normal Div, Centered) -->
  <div *ngIf="!auditoriumDetails || auditoriumDetails.length === 0"
    class="d-flex justify-content-center align-items-center text-center py-5">
    <div>
      <i class="fas fa-building fa-3x text-secondary mb-2"></i>
      <div class="fw-bold text-secondary">-- No auditoriums found --</div>
    </div>
  </div>
</div>







<!-- Modal is rendered only if auditoriumModel is true -->
<div [style.display]="auditoriumModel ? 'block' : 'none'" class="modal fade show" tabindex="-1" role="dialog"
  aria-hidden="true" style="background-color: rgba(0,0,0,0.5);">
  <div class="modal-dialog modal-lg modal-dialog-centered">
    <div class="modal-content border-0 rounded-3 shadow">

      <!-- Modal Header -->
      <div class="modal-header">
        <h5 class="modal-title fw-bold">{{ isEdit ? 'Edit' : 'Add New' }} Auditorium</h5>
        <button type="button" class="btn-close" (click)="close()"></button>
      </div>

      <!-- Modal Body -->
      <div class="modal-body">
        <!-- FORM START -->
        <form [formGroup]="auditoriumForm" (ngSubmit)="formValidation()">
          <div class="row g-3">

            <!-- Location -->
            <div class="col-md-6">
              <label for="location" class="form-label">Location</label>
              <input type="text" id="location" formControlName="location" class="form-control"
                placeholder="Enter location">
              <div class="error text-danger"
                *ngIf="(submitted || auditoriumForm.get('location')?.touched) && auditoriumFormErrors.location">
                {{ auditoriumFormErrors.location }}
              </div>
            </div>

            <!-- School Name -->
            <div class="col-md-6">
              <label for="schoolName" class="form-label">School Name</label>
              <input type="text" id="schoolName" formControlName="schoolName" class="form-control"
                placeholder="Enter school name">
              <div class="error text-danger"
                *ngIf="(submitted || auditoriumForm.get('schoolName')?.touched) && auditoriumFormErrors.schoolName">
                {{ auditoriumFormErrors.schoolName }}
              </div>
            </div>

            <!-- Auditorium Image Upload -->
            <div class="col-md-12">
              <label for="auditoriumImage" class="form-label">Auditorium Image</label>
              <input type="file" id="auditoriumImage" class="form-control" (change)="onFileSelected($event)"
                accept=".png, .jpg, .jpeg" #fileInput>
              <!-- <div class="error text-danger" *ngIf="(submitted || fileTouched) && auditoriumFormErrors.filePath">
                {{ auditoriumFormErrors.filePath }}
              </div> -->
            </div>

          </div>

          <!-- Modal Footer inside form so submit works -->
          <div class="modal-footer mt-4">
            <button type="button" class="btn btn-secondary" (click)="close()">Cancel</button>
            <button type="submit" class="btn btn-primary">
              {{ isEdit ? 'Update' : 'Save' }}
            </button>
          </div>
        </form>
      </div>

    </div>
  </div>
</div>


<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium">
  <div class="loader">
    <div class="inner one"></div>
    <div class="inner two"></div>
    <div class="inner three"></div>
  </div>
</ngx-spinner>